import * as React from "react";
import { Funding, Modernizations } from "../../calcBusterTypes";
import { Box, Button, PieChart } from "@amzn/awsui-components-react";
import { USDollar } from "../../util";

const ModernizationPieChart = (
  modernizations: Modernizations,
  funding: Funding
) => {
  const modernizationAnnualRunRate = modernizations.annualRunRate ?? 0;
  const annualRunRate = funding.annualRunRate ?? 0;

  const data = [
    {
      title: "Modern Services",
      value: modernizationAnnualRunRate,
    },
    {
      title: "Other",
      value: annualRunRate - modernizationAnnualRunRate,
    },
  ];

  return (
    <>
      <Box variant="awsui-key-label">Modernization Index</Box>
      <PieChart
        legendTitle="Modernization Categories"
        hideFilter
        hideLegend
        data={data}
        detailPopoverContent={(datum, sum) => [
          {
            key: "Annual Run Rate",
            value: `${USDollar.format(datum.value)}`,
          },
          {
            key: "Percentage",
            value: `${((datum.value / sum) * 100).toFixed(0)}%`,
          },
        ]}
        segmentDescription={(datum, sum) =>
          `${USDollar.format(datum.value)} , ${(
            (datum.value / sum) *
            100
          ).toFixed(0)}%`
        }
        ariaDescription="Pie chart showing how many resources are currently in which state."
        ariaLabel="Pie chart"
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
            <Button>Clear filter</Button>
          </Box>
        }
      />
    </>
  );
};

export default ModernizationPieChart;
